module.exports = __webpack_public_path__ + "assets/img/7.969853ec.jpg";